import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTodoListComponent } from './fi-todo-list.component';
import { FiAppTextSharedModule } from '../../../shared/app-text';
import { FiItemsListModule } from '../../../shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '../../../shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '../../../shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { FiWhenScrolledModule } from '../../../shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatMenuModule,
        MatSortModule,
        FiWhenScrolledModule,
        FiEmptyListModule,
        FiLoadingModule,
    ],
    declarations: [FiTodoListComponent],
})
export class FiTodoListModule {}
